import React, { useContext } from 'react';
import { AlumnosContext } from '../context/alumnos/AlumnosContext';
import { UserContext } from '../context/users/UserContext';
import { FormLabel, FormInputStyled, FormInputContainer } from '../assets/styled';

export default function FormInput({ tipo, noLabel, abm }) {
	const alumnoCtx = useContext(AlumnosContext);
	const userCtx = useContext(UserContext);

	const { handleChange, authStatus } = userCtx;
	const { handleChangeAlumno, data } = alumnoCtx;

	const options = {
		username: { titulo: 'Nombre de usuario', type: 'text' },
		email: { titulo: 'Direccion de E-Mail', type: 'mail' },
		password: { titulo: 'Contraseña', type: 'password' },
		nombre: { titulo: 'Nombre', type: 'text' },
		apellido: { titulo: 'Apellido', type: 'text' },
		dni: { titulo: 'DNI', type: 'number' },
		categoria: { titulo: 'Categoria', type: 'string' },
		fechaNacimiento: { titulo: 'Fecha de Nacimiento', type: 'date' },
		pago: { titulo: 'Pago', type: 'number' },
	};

	return (
		<FormInputContainer mt={!noLabel} fullWidth={abm}>
			{!noLabel && (
				<FormLabel htmlFor={tipo}>
					{options[tipo].titulo}
				</FormLabel>
			)}
			<FormInputStyled
				placeholder={options[tipo].titulo}
				id={tipo}
				name={tipo}
				type={options[tipo].type}
				required
				value={data[tipo]}
				onChange={(e) => {
					authStatus ? handleChangeAlumno(e) : handleChange(e);
				}}
			/>
		</FormInputContainer>
	);
}
